import Api from "~/service/Api";

class Immersive3dTourFloorPlanImportRepository {
  update(tourId, data) {
    return Api.post(`/immersive-3d-tour/floor-plan/imports/${tourId}`, data);
  }
}

export default Immersive3dTourFloorPlanImportRepository;
